import { render, staticRenderFns } from "./TransferMoneyDialog.vue?vue&type=template&id=89f38efa&scoped=true&"
import script from "./TransferMoneyDialog.vue?vue&type=script&lang=js&"
export * from "./TransferMoneyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f38efa",
  null
  
)

export default component.exports